export interface NavItem {
  label: string
  subLabel?: string
  children?: Array<NavItem>
  href?: string
  onToggle?: () => void
}

// Get domain and language from actual URL
const getDomainAndLanguage = () => {
  const hostname = window.location.hostname

  // Local development
  if (hostname === 'localhost') {
    return {
      domain: 'snovio.sk',
      language: 'sk',
    }
  }

  // Production
  if (hostname.includes('snovio.cz')) {
    return {
      domain: 'snovio.cz',
      language: 'cs',
    }
  }

  // Default to Slovak
  return {
    domain: 'snovio.sk',
    language: 'sk',
  }
}

const { domain, language } = getDomainAndLanguage()

export { domain, language }

const NAV_ITEMS_SK: Array<NavItem> = [
  {
    label: 'Domov',
    href: '',
  },
  {
    label: 'Výklad snov',
    href: '/vyklad',
  },
  {
    label: 'Snár',
    href: '/snar',
  },
  {
    label: 'Blog',
    href: '/blog',
  },
]

const NAV_ITEMS_CS: Array<NavItem> = [
  {
    label: 'Domů',
    href: '',
  },
  {
    label: 'Výklad snů',
    href: '/vyklad',
  },
  {
    label: 'Snář',
    href: '/snar',
  },
  {
    label: 'Blog',
    href: '/blog',
  },
]

export const NAV_ITEMS = language === 'cs' ? NAV_ITEMS_CS : NAV_ITEMS_SK

export type Meaning = { symbol: string; detail: string; meaning: string }

export const pageTitle = (title: string) => `${title} | Snovio`
